/**
 * API CLIENT
 * Handles all HTTP requests to the backend
 */

// This will be auto-generated during deployment
const API_URL = 'https://ghl-financial-api.ghlboysclub.workers.dev'

interface RequestOptions {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE'
  headers?: Record<string, string>
  body?: any
}

class ApiClient {
  private baseURL: string

  constructor(baseURL: string) {
    this.baseURL = baseURL
  }

  private async request(endpoint: string, options: RequestOptions = { method: 'GET' }) {
    const token = localStorage.getItem('token')

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...options.headers,
    }

    if (token) {
      headers['Authorization'] = `Bearer ${token}`
    }

    const config: RequestInit = {
      method: options.method,
      headers,
      credentials: 'include', // Send cookies
    }

    if (options.body && options.method !== 'GET') {
      config.body = JSON.stringify(options.body)
    }

    try {
      const response = await fetch(`${this.baseURL}/api${endpoint}`, config)

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}))
        throw new Error(errorData.message || errorData.error || 'Request failed')
      }

      return await response.json()
    } catch (error: any) {
      console.error('API Error:', error)
      throw error
    }
  }

  async get(endpoint: string) {
    return this.request(endpoint, { method: 'GET' })
  }

  async post(endpoint: string, body: any) {
    return this.request(endpoint, { method: 'POST', body })
  }

  async put(endpoint: string, body: any) {
    return this.request(endpoint, { method: 'PUT', body })
  }

  async delete(endpoint: string) {
    return this.request(endpoint, { method: 'DELETE' })
  }
}

export const apiClient = new ApiClient(API_URL)
